import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import store from '../../../helpers/store'
import {
  uniq,
  map,
  merge,
  find,
  flatten,
  findKey,
  isEqual,
  get,
  cloneDeep
} from 'lodash';
import {
  Dropdown
} from 'react-bootstrap';
import {
  connect
} from 'react-redux';

// import Tooltip from 'rc-tooltip';
import Slider from 'rc-slider';
import ReactTooltip from 'react-tooltip';
import Datepicker from '../../common/Datepicker';
import Multiselect from '../../common/Multiselect/Multiselect';
//import MultiselectWithSearch from '../../common/MultiselectWithSearch';
import Accordion from '../spotifyMonetizationFilter/Accordion';
import ReactSelect from '../../common/ReactSelect';
import FilterButton from './FilterButton';

import Spinner from '../../common/Spinner';
import ClickOutsideHolder from '../../../helpers/ClickOutsideHolder'
import MatchMediaWrapper from '../../../helpers/MatchMediaWrapper';
import Tooltip from '../../common/Tooltip';
import ConfirmClick from '../../common/ConfirmClick';
import Modal from '../../common/Modal';

import SearchWidget from '../../pages/home/SearchWidget';

import statusesValues from './enums/statuses';
import releaseDatesValues from './enums/releaseDates.json';
import monthsValues from './enums/months.json';

var tagSvg = require('!svg-inline-loader!../../../../public/img/tag.svg');
var searchSvg = require('!svg-inline-loader!../../../../public/img/search.svg');

const dateFormat = 'YYYY-MM-DD';
const accordionSettings = [
  {
    id: "entities", title: "Entity", description: "Search imprints, artists, products, tracks..."
  },
  {
    id: "text", title: "Title, Notes & Tags", description: "Search by Title, Notes or Tags"
  },
  {
    id: "occurs_at", title: "Start Date", description: "Filter by Start date range"
  },
  {
    id: "ends_at", title: "End Date", description: "Filter by end date range"
  },
  {
    id: "added_at", title: "Added At", description: "Filter by Added at range"
  },


];

const defaultFilterState = {
  entity_id: null,
  entity_type: null,
  entity_title: '',
  reference: '',
  notes: '',
  tag: '',
  occurs_start: null, 
  occurs_end: null, 
  ends_start: null, 
  ends_end: null, 
  added_start: null, 
  added_end: null
}

class Filter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...defaultFilterState,
      accordion: {
        entities: false,
        text: false,
        occurs_at: false,
        ends_at: false,
        added_at: false,
      }, 
      search: "",
      matchingIds: ["entities", "text", "occurs_at", "ends_at", "added_at"],
      display: [],
      currentPlaylistFilterID: null
    }

    this.setSearch = this.setSearch.bind(this);
  }
      

  componentWillMount(){
      
  }
    

  toggleAccordion = (selectedKey) => {
    let { accordion } = this.state;
    for (let key in accordion) {
        accordion[key] = (key == selectedKey) ? !accordion[key] : false;
    }
    this.setState({
        accordion
      })
  }
  
  filterOptionChange = (value, key) => {
    this.setState({
      [key]: value
    }, ()=>{
    })
  }
  
    removeFromFilter = () => {
    this.setState({
      entity_id: null,
      entity_type: null,
      entity_title: ''
    });
  }
    
  filterReset = () => {
    this.setState({
      ...this.state,
      ...defaultFilterState,
      filtered: {},
      display: []
    })
  }
  
  removeOption = (option, apply = true) => {
    const newState = {};

    switch (option) {
      case 'entity_title':
        newState.entity_id = null;
        newState.entity_type = null;
        newState.entity_title = '';
        break;

      case 'reference':
      case 'notes':
      case 'tag':
        newState[option] = '';
        break;

      case 'occurs_start':
        newState.occurs_start = null;
        newState.occurs_end = null;
        break;

      case 'ends_end':
        newState.ends_start = null;
        newState.ends_end = null;
        break;

      case 'added_end':
        newState.added_start = null;
        newState.added_end = null;
        break;

      default:
        return;
    }

    this.setState(newState, () => {
      if (apply) this.filterApply();
    });
  }
  
  addToFilter = (entity) => {
    this.setState({
      entity_id: String(entity.id),
      entity_type: entity.entity,
      entity_title: entity.name_raw
    });
  }
  

    dateChange(date, propDate) {
      date = moment(date).format(dateFormat);
      this.filterOptionChange(date, propDate);
    }

    
    renderDisplay = (entity_title, entity_type, entity_id, hasIcon) => {
      const extraClass = hasIcon ? "with-icon" : "";
      return <div className="tag-list">
          <div className="page-filter-item">
              <div className="page-filter-list">
                  <div key={entity_id} className={`tag ${entity_type}`}>
                      <div className={`tag-name-holder ${extraClass}`}>
                        { hasIcon ? <span className="playlist-tag-icon" dangerouslySetInnerHTML={{__html: tagSvg}}></span> : null }
                          <div className="tag-name">
                              <span>{entity_title}</span>
                          </div>
                          <a
                              className="close-link"
                              onClick={this.removeFromFilter}
                          >
                              &times;
                          </a>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    }
    
    filterApply = () => {
      const filterData = {
        ...this.state
      }
      this.props.onApply(filterData, this.state.display);
    }
    
    getAccordionHeader(entity) {
      const accordionItem = accordionSettings.find(item => item.id === entity);

      if (!accordionItem) {
        return null;
      }

      return <div className="playlist-filter-accordion-label">
        <span className="playlist-filter-result-icon" dangerouslySetInnerHTML={{__html: tagSvg}}></span>
        <div className="playlist-filter-accordion-label-text">
          <span className="playlist-filter-accordion-label-title">{accordionItem.title}</span>
          <span className="playlist-filter-accordion-label-placeholder">{accordionItem.description}</span>
        </div>
      </div>
    }

    setSearch(e) {
      const value = e.target.value;
      
      this.setState({
        search: value,
      });
      
      this.getMatchingIds(value);
    }
   
    onDatepickerExpand(datepickerContainer, datepickerState){
      this.setState({
        datepickerContainer,
        datepickerContainerHeight: datepickerState.height,
        isExpanded: datepickerState.expanded
      })
    }
    
    getMatchingIds(value) {
      const matchingIds = [];
      
      accordionSettings.forEach(setting => {
        if (setting.title.match(new RegExp(value, 'i')) || setting.description.match(new RegExp(value, 'i'))) {
          matchingIds.push(setting.id);
        }
      });

      if (value.length > 0 && value.length < 3) {
        return;
      }

      this.setState({
        matchingIds
      })
    }
    
    getMaxDate(field){
      return moment().format(dateFormat);
    }

    render() {
      const { expanded } = this.props;
      if(!expanded)
        return null;
        
      const { display, matchingIds, entity_title, entity_type, entity_id } = this.state;
      
        return <div className={`filter-wrapper filter-opened playlist-filter`}>
          <div className="filter-summary-holder playlist-filter-summary-holder">            
            <div className="filterSpinner">
              <Spinner enabled={this.props.loading} />
            </div>
            <form role="form" className="form-inline">
                <div className="filter-wrapper-inner">
                    <div className='search-widget'>
                    <form role="form" className="form-inline">
                      <div className="form-group search">
                        <input
                          className={`form-control main-search-input`}
                          placeholder={
                            "Search Filters"
                          }
                          type="text"
                          value={this.state.search}
                          onChange={this.setSearch}
                          />
                      </div>
                    </form>
                    </div>
                    <div className="advanced-filter">
                      <div className="advanced-filter-inner">
                        <Accordion className="chosen-group filter-option-group" id="entities" label={this.getAccordionHeader("entities")} accordion={this.state.accordion} filter={this.state} toggleAccordion={this.toggleAccordion} matchingIds={matchingIds}>
                          <SearchWidget searchResult={this.addToFilter} placeholder="Search Catalog..." mode="playlist" searchItemMode="single" searchDropdownMode="single" noSearchBtn={true} batch={false}  />
                          {entity_title && this.renderDisplay(entity_title, entity_type, entity_id, false)}
                        </Accordion>
                        <Accordion className="chosen-group filter-option-group" id="text" label={this.getAccordionHeader("text")} accordion={this.state.accordion} filter={this.state} toggleAccordion={this.toggleAccordion} matchingIds={matchingIds}>
                          <div className="form-control-item">
                            <span>Title:</span> <input type="text" className="form-control" value={this.state.reference} onChange={e=>this.filterOptionChange(e.target.value, 'reference')} />
                          </div>
                          <div className="form-control-item">
                            <span>Notes:</span> <input type="text" className="form-control" value={this.state.notes} onChange={e=>this.filterOptionChange(e.target.value, 'notes')} />
                          </div>
                          <div className="form-control-item">
                            <span>Tag:</span>
                            <input type="text" className="form-control" value={this.state.tag} onChange={e=>this.filterOptionChange(e.target.value, 'tag')} />
                          </div>
                        </Accordion>
                        <Accordion className="chosen-group filter-option-group" id="occurs_at" label={this.getAccordionHeader("occurs_at")} accordion={this.state.accordion} filter={this.state} toggleAccordion={this.toggleAccordion} matchingIds={matchingIds}>
                          <div className="daterange-item">
                            <div className="daterange-container">
                                <Datepicker endDate={this.getMaxDate('releaseStart')} date={this.state.occurs_start} label="From" dateChange={(date)=>this.dateChange(date, 'occurs_start')} placeholder="Start Date" showYearDropdown selectsStart={true} onExpand={(datepickerProps)=>this.onDatepickerExpand('previous', datepickerProps)}  />
                                <span className='fas fa-long-arrow-alt-right'></span>
                                <Datepicker endDate={this.getMaxDate('releaseEnd')} startDate={this.state.occurs_start} date={this.state.occurs_end} label="To" dateChange={(date)=>this.dateChange(date, 'occurs_end')} placeholder="Today" className="form-control text-right" showYearDropdown selectsEnd={true} monthsShown={1} onExpand={(datepickerProps)=>this.onDatepickerExpand('previous', datepickerProps)} />
                            </div>
                          </div>
                        </Accordion>
                        <Accordion className="chosen-group filter-option-group" id="ends_at" label={this.getAccordionHeader("ends_at")} accordion={this.state.accordion} filter={this.state} toggleAccordion={this.toggleAccordion} matchingIds={matchingIds}>
                          <div className="daterange-item">
                            <div className="daterange-container">
                                <Datepicker endDate={this.getMaxDate('releaseStart')} date={this.state.ends_start} label="From" dateChange={(date)=>this.dateChange(date, 'ends_start')} placeholder="Start Date" showYearDropdown selectsStart={true} onExpand={(datepickerProps)=>this.onDatepickerExpand('previous', datepickerProps)}  />
                                <span className='fas fa-long-arrow-alt-right'></span>
                                <Datepicker endDate={this.getMaxDate('releaseEnd')} startDate={this.state.ends_start} date={this.state.ends_end} label="To" dateChange={(date)=>this.dateChange(date, 'ends_end')} placeholder="Today" className="form-control text-right" showYearDropdown selectsEnd={true} monthsShown={1} onExpand={(datepickerProps)=>this.onDatepickerExpand('previous', datepickerProps)} />
                            </div>
                          </div>
                        </Accordion>
                        <Accordion className="chosen-group filter-option-group" id="added_at" label={this.getAccordionHeader("added_at")} accordion={this.state.accordion} filter={this.state} toggleAccordion={this.toggleAccordion} matchingIds={matchingIds}>
                          <div className="daterange-item">
                            <div className="daterange-container">
                                <Datepicker endDate={this.getMaxDate('releaseStart')} date={this.state.added_start} label="From" dateChange={(date)=>this.dateChange(date, 'added_start')} placeholder="Start Date" showYearDropdown selectsStart={true} onExpand={(datepickerProps)=>this.onDatepickerExpand('previous', datepickerProps)}  />
                                <span className='fas fa-long-arrow-alt-right'></span>
                                <Datepicker endDate={this.getMaxDate('releaseEnd')} startDate={this.state.added_start} date={this.state.added_end} label="To" dateChange={(date)=>this.dateChange(date, 'added_end')} placeholder="Today" className="form-control text-right" showYearDropdown selectsEnd={true} monthsShown={1} onExpand={(datepickerProps)=>this.onDatepickerExpand('previous', datepickerProps)} />
                            </div>
                          </div>
                        </Accordion>

                      </div>
                    </div>
                    <ul className="saved-filters">
                      <div className="form-group button-container">
                        <button className="apply-btn" alt="apply" type="button" onClick={this.filterApply}>Apply Filter</button>
                      </div>
                      <div className="form-group reset-link-container">
                          <a className="reset-filter-link" onClick={(e)=>this.filterReset(e)}>Reset to default</a>
                      </div>
                    </ul>
                </div>
              </form>
          </div>
            
        </div>
    }
}

function mapDispatchToProps(dispatch){
  return {
    getEntityFilters: () => dispatch(userEntityFiltersActions.getUserEntityFilters()),
  }
      
}

function mapStateToProps(state) {
  return {
      filter: state.filter,
      userEntityFilters: state.userEntityFilters
  }
}
export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(Filter)